<section class="beauty-intro section-padding">
    <div class="container">
        <div class="row align-items-center g-5">

            <div class="col-lg-6">
                <div class="beauty-intro-content">

                    <span class="section-badge">
                        {{ 'beautyIntro.eyebrow' | translate }}
                    </span>

                    <h2 class="section-title">
                        {{ 'beautyIntro.title' | translate }}
                    </h2>

                    <p class="section-subtitle">
                        {{ 'beautyIntro.subtitle' | translate }}
                    </p>

                    <div class="beauty-benefits">

                        <div class="beauty-benefit">
                            <i class="fas fa-calendar-check" aria-hidden="true"></i>
                            <div>
                                <h3>
                                    {{ 'beautyIntro.benefit1Title' | translate }}
                                </h3>
                                <p>
                                    {{ 'beautyIntro.benefit1Text' | translate }}
                                </p>
                            </div>
                        </div>

                        <div class="beauty-benefit">
                            <i class="fas fa-scissors" aria-hidden="true"></i>
                            <div>
                                <h3>
                                    {{ 'beautyIntro.benefit2Title' | translate }}
                                </h3>
                                <p>
                                    {{ 'beautyIntro.benefit2Text' | translate }}
                                </p>
                            </div>
                        </div>

                        <div class="beauty-benefit">
                            <i class="fas fa-users" aria-hidden="true"></i>
                            <div>
                                <h3>
                                    {{ 'beautyIntro.benefit3Title' | translate }}
                                </h3>
                                <p>
                                    {{ 'beautyIntro.benefit3Text' | translate }}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="beauty-image">
                    <img src="assets/images/beauty-salon-scheduling.png"
                        alt="Beauty salon professional managing client appointments" loading="lazy" width="1536"
                        height="1024" />
                </div>
            </div>

        </div>
    </div>
</section>